import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLocale } from "@/contexts/LocaleContext";
import ProjectCard from "@/components/ProjectCard";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Building2 } from "lucide-react";

export default function Projects() {
  const { t } = useLocale();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [onlyConfotur, setOnlyConfotur] = useState(false);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (q) params.q = q;
    if (onlyConfotur) params.confotur = true;
    api.get("/projects", { params })
      .then(({ data }) => setItems(data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [q, onlyConfotur]);

  return (
    <div className="mx-auto max-w-7xl px-4 md:px-10 pt-8 md:pt-16 pb-16">
      {/* Hero band */}
      <div className="relative overflow-hidden bg-primary text-primary-foreground rounded-2xl px-6 md:px-12 py-10 md:py-14 mb-10">
        <div className="max-w-2xl relative z-10">
          <div className="inline-flex items-center gap-2 label-eyebrow text-primary-foreground/80 mb-3">
            <Building2 className="h-4 w-4" /> {t("nav.projects")}
          </div>
          <h1 className="font-serif text-4xl md:text-6xl leading-[1.05]">{t("projects.title")}</h1>
          <p className="mt-4 text-primary-foreground/80 max-w-xl text-sm md:text-base">
            {t("projects.sub")}
          </p>
        </div>
        <div className="absolute -right-16 -bottom-16 h-72 w-72 rounded-full bg-secondary/25 blur-3xl" />
        <div className="absolute -right-24 top-8 h-56 w-56 rounded-full bg-accent/20 blur-2xl" />
      </div>

      <div className="mb-8 flex flex-wrap items-center gap-4">
        <div className="flex-1 min-w-[220px]">
          <Input
            data-testid="projects-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Torre Costa Verde, Punta Cana…"
          />
        </div>
        <label className="inline-flex items-center gap-2 text-sm">
          <Checkbox
            checked={onlyConfotur}
            onCheckedChange={(v) => setOnlyConfotur(v === true)}
            data-testid="projects-confotur-filter"
          />
          <span>Solo con {t("projects.confotur")}</span>
        </label>
        <span className="ml-auto text-sm text-muted-foreground">{items.length} proyectos</span>
      </div>

      {loading ? (
        <div className="py-16 text-center text-muted-foreground text-sm">{t("common.loading")}</div>
      ) : items.length === 0 ? (
        <div className="py-16 text-center text-muted-foreground text-sm" data-testid="projects-empty">
          {t("projects.empty")}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14" data-testid="projects-grid">
          {items.map((p, i) => (
            <ProjectCard key={p.project_id} project={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
